import { FC } from 'react'

type CircleStatusProps = {
  status: number
}

const CircleStatus:FC<CircleStatusProps> = ({ status }) => {
  let bgColor = ''

  if(status === 1) bgColor = '#51CF66'
  else if(status === 2) bgColor = '#FF7E7E'
  else if(status === 3) bgColor = '#FFDF6B'

  return <span className="d-inline-block" style={{ width: 10, height: 10, borderRadius: '100%', backgroundColor: bgColor }}></span>
}

export { CircleStatus }